import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Nav4AppMenuItem } from '../app-menu-item/Nav4AppMenuItem.tsx';
import type { Nav4ForgeMenuItem$key } from './__generated__/Nav4ForgeMenuItem.graphql';

type Nav4ForgeMenuItemProps = {
	queryRef: Nav4ForgeMenuItem$key;
	currentItems?: Array<{ id: string; label: string }>;
	currentOrder?: Array<{ menuId: string; visible: boolean }>;
	item?: {
		id: string;
		label: string;
	};
};

export function Nav4ForgeMenuItem({
	queryRef,
	currentItems,
	currentOrder,
	item,
}: Nav4ForgeMenuItemProps): React.JSX.Element {
	// eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
	const data = useFragment<Nav4ForgeMenuItem$key>(
		graphql`
			fragment Nav4ForgeMenuItem on JiraAppNavigationItem {
				...Nav4AppMenuItem
			}
		`,
		// eslint-disable-next-line @atlassian/relay/use-fragment-naming
		queryRef,
	);

	return (
		<Nav4AppMenuItem
			queryRef={data}
			currentItems={currentItems}
			currentOrder={currentOrder}
			item={item}
		/>
	);
}
